<template>
  <UBadge
    class="rounded-2xl pl-0.5 pr-3.5 gap-3 py-0.5"
    size="xl"
    color="neutral"
    variant="soft"
    :class="ui?.root"
  >
    <template #leading>
      <div class="flex items-center">
        <div
          class="flex h-8 w-8 items-center justify-center rounded-full bg-accent-default text-white"
          :class="ui?.icon"
        >
          <Icon name="i-local-navigation" />
        </div>
      </div>
    </template>

    <div class="typo-paragraph-sm-medium">
      <slot />
    </div>
  </UBadge>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'LocationBadge',
})

defineProps<{
  ui?: {
    root?: string
    icon?: string
  }
}>()
</script>
